/* © 2022 Promethean. All Rights Reserved.
 *
 * Unauthorized copying of this file or any part of this file
 * via any medium is strictly prohibited.
 */
import React from 'react';
import { useIntl } from 'react-intl';
import { PageTemplate } from '../../templates/pageTemplate';
import { ContentTemplate } from '../../templates/contentTemplate';
import NotFoundErrorImage from './assets/image-error-404.svg';
import { useDocumentTitle } from '../../utils/useDocumentTitle';
export var NotFoundError = function NotFoundError(props) {
  var _mixpanelProps$tracke, _mixpanelProps$tracke2;
  var onBack = props.onBack,
    mixpanelProps = props.mixpanelProps;
  var intl = useIntl();
  useDocumentTitle(intl.formatMessage({
    id: 'embers.pageTitle.error.notFound',
    defaultMessage: 'Oops! Page not found - Promethean'
  }));
  mixpanelProps === null || mixpanelProps === void 0 || (_mixpanelProps$tracke = (_mixpanelProps$tracke2 = mixpanelProps.tracker).mixpanelTrackHelper) === null || _mixpanelProps$tracke === void 0 || _mixpanelProps$tracke.call(_mixpanelProps$tracke2, 'Page Not Found');
  return /*#__PURE__*/React.createElement(PageTemplate, null, /*#__PURE__*/React.createElement(ContentTemplate, {
    type: "error",
    pageTitle: intl.formatMessage({
      id: 'embers.globalError.notFound.title',
      defaultMessage: 'Oops! Page not found'
    }),
    errorMessage: intl.formatMessage({
      id: 'embers.globalError.notFound.body',
      defaultMessage: 'Please accept our sincere apologies for not being able to locate the requested page. If you would like to go back to the previous page, click the button below.'
    }),
    errorImage: NotFoundErrorImage,
    onBack: onBack
  }));
};